/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityExam = require('../services/GetEntityExam');

var GetAllExamsLookups = require('../services/GetAllExamsLookups');

var DepExamRatingEditView = require('../views/DepExamRatingEditView');

module.exports = function(entityId, examId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntityIdentifiers(entityId), GetEntityExam(examId))
    .done(function(entityIdentifiers, exam) {
      GetAllExamsLookups(entityIdentifiers.categoryId)
        .done(function(examLookups) {
          NavUtils.navigate('#dep/entity/' + entityId + '/exam/' + examId + '/edit-rating');

          Scaffold.content.show(
            new DepExamRatingEditView({
              model: new Backbone.Model({
                entityId: entityId,
                entityName: entityIdentifiers.entityName,
                entityTypeId: entityIdentifiers.entityTypeId,
                entityCategoryId: entityIdentifiers.categoryId,
                entityCharterTypeId: entityIdentifiers.charterTypeId,
                lookups: examLookups,
                exam: exam
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
